import LandingPageLayout from '@/components/Layouts/LandingPageLayout'
import { FixedReportIssueButton } from '@/components/FixedReportIssueButton'
import Image from 'next/image'
import Head from 'next/head'
import T from '@/components/Helpers/Translate'
import { Button } from '@/components/_ui/Button'
import Link from 'next/link'

export default function UnsupportedMarket() {
  return (
    <>
      <Head>
        <title>Unsupported Market</title>
        <meta
          name="description"
          content="This market is currently not supported"
        />
      </Head>

      <LandingPageLayout>
        <FixedReportIssueButton />

        <div>
          <main className="m-auto mt-10 flex min-h-screen max-w-[1400px] flex-col items-center overflow-x-hidden px-4 py-12">
            <div className="flex max-w-2xl flex-col items-center justify-center gap-8 text-center">
              <div className="relative size-48">
                <Image
                  src="/icons/404.svg"
                  alt="Market not available"
                  fill
                  className="object-contain"
                />
              </div>

              <div className="space-y-4">
                <h2 className="text-2xl font-bold text-gray-800 md:text-3xl">
                  <T>market_not_supported</T>
                </h2>
                <p className="text-lg text-gray-600">
                  <T>this_market_not_supported</T>
                </p>
                <p className="text-gray-600">
                  <T>please_visit_later_or_contact</T>
                </p>
              </div>

              <Link href="/">
                <Button size="lg" variant="secondary">
                  <T>return_to_homepage</T>
                </Button>
              </Link>
            </div>
          </main>
        </div>
      </LandingPageLayout>
    </>
  )
}
